import React from "react";

import { useAuth } from "../../contexts/AuthContext";
import { Button } from "../ui/button";

const AuthContent = () => {
  const { user, signIn, signOut, isLoading } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  const handleSignIn = async () => {
    try {
      console.log("Starting sign in process...");
      await signIn();
    } catch (error) {
      console.error("Sign in error:", error);
    }
  };

  if (isLoading) {
    return <div className="text-center text-gray-500">Loading...</div>;
  }

  if (user) {
    return (
      <div className="space-y-2">
        <div className="text-sm text-gray-600">Signed in as {user.email}</div>
        <Button variant="outline" onClick={handleSignOut} className="w-full">
          Sign Out
        </Button>
      </div>
    );
  }

  return (
    <>
      <Button onClick={handleSignIn} className="w-full">
        Sign up
      </Button>
      <p className="mt-3 text-xs text-center text-gray-700">
        By signing up you agree to our{" "}
        <a
          href="/terms"
          className="underline hover:text-gray-800 transition-colors"
        >
          Terms & Conditions
        </a>{" "}
        and{" "}
        <a
          href="/privacy"
          className="underline hover:text-gray-800 transition-colors"
        >
          Privacy Policy
        </a>
      </p>
    </>
  );
};

const AuthComponent = () => {
  return <AuthContent />;
};

export default AuthComponent;
